import React, { useEffect, useState } from 'react';
import styles from '../../Dashboard.module.scss';
import SVG from 'react-inlinesvg';
import { getCountryIcon } from '../../Utils/dashboardUtils';

//tr

import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

//assets
import ALL_DISABLED from '../../../../assets/icons/ALL_DISABLED.svg';
import ONLY_FORECASTS from '../../../../assets/icons/ONLY_FORECASTS.svg';
import ALL_ENABLED from '../../../../assets/icons/ALL_ENABLED.svg';
import CUSTOM from '../../../../assets/icons/CUSTOM.svg';

export const StatsTable: React.FC<any> = (props) => {
  const { data, label } = props;

  return (
    <div className={styles.statsTableWrapper}>
      {data &&
        data.map((element: any) => {
          return <StatsTableItem element={element} label={label} />;
        })}
    </div>
  );
};
interface OwnProps {
  label: string;
  element: { key: string; value: string };
}

const StatsTableItem = ({ label, element }: OwnProps) => {
  const { key, value } = element;

  const [iconData, setIconData] = useState(<label />);
  const { t } = useTranslation();

  const getNotificationsIcon = (key: string) => {
    switch (key) {
      case 'ALL_DISABLED':
      case 'Todas desactivadas':
        return <SVG src={ALL_DISABLED}></SVG>;
      case 'ONLY_FORECASTS':
      case 'ONLY_TIPS':
      case 'Solo los pronosticos':
        return <SVG src={ONLY_FORECASTS}></SVG>;
      case 'ALL_ENABLED':
      case 'Todas activadas':
        return <SVG src={ALL_ENABLED}></SVG>;
      case 'CUSTOM':
      case 'Personalizadas':
        return <SVG src={CUSTOM}></SVG>;
      default:
        return <label />;
    }
  };

  const getKey = (key: string) => {
    switch (label) {
      case 'countries':
        return key === 'OT' ? tr(t, 'other') : key.toUpperCase();
      case 'languages':
        return key === 'OT' ? tr(t, 'other') : key.toUpperCase();
      case 'notifications_settings':
        return tr(t, key);
      default:
        return;
    }
  };
  const getIcon = async (key: string) => {
    switch (label) {
      case 'countries':
        const icon = await getCountryIcon(key);
        setIconData(<SVG src={icon}></SVG>);
        break;
      case 'languages':
        setIconData(<label />);
        break;
      case 'notifications_settings':
        setIconData(getNotificationsIcon(key));
        break;
      default:
        return;
    }
  };
  useEffect(() => {
    getIcon(key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.tableElement} key={key}>
      <div className={styles.iconWrapper}>
        {iconData} <p>{getKey(key)}</p>
      </div>
      <p>{value}%</p>
    </div>
  );
};
